import React, { FC } from 'react';

import { Button } from '../../../../../button';
import { Modal } from '../../../../../modal/modal.component';
import { ModalIds } from '../../../../../../contexts/modals/modals.types';
import { Typography } from '../../../../../../../../../components';
import { capitalize } from 'lodash';
import styles from './success.module.scss';
import { useSuccessData } from './success.hook';

/**
 * Success component
 * @description Exclusively for the RenamePortfolio flow as its Success stage.
 * @link https://www.figma.com/file/16ideRW6XB1s57uA93ppSl/Manager--%7C-File-for-development?type=design&node-id=2305-160844&mode=dev
 *
 * @author Oleksii Medvediev
 * @category Components
 */
const Success: FC = () => {
  const { t, flowData, handleSubmitSuccess } = useSuccessData();

  return (
    <Modal modalId={ModalIds.renamePortfolioSuccess} title={t('modals.renamePortfolio.success.title')}>
      <div className={styles.wrapper}>
        <Typography.Text variant={'bodyText5'}>
          {t('modals.renamePortfolio.success.description', {
            oldPortfolioName: flowData?.oldPortfolioName,
            newPortfolioName: flowData?.newPortfolioName,
          })}
        </Typography.Text>
        <Button size={'large'} type={'button'} variant={'main'} onClick={handleSubmitSuccess}>
          {capitalize(t('modals.renamePortfolio.success.continue'))}
        </Button>
      </div>
    </Modal>
  );
};

export { Success };
